import { Link } from "react-router-dom";
import { Mail, LifeBuoy, ShieldCheck, FileText, Trash2 } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHeader } from "@/components/PagePrimitives";
import ContactForm from "@/components/ContactForm";
import Reveal from "@/components/Reveal";
import { SITE } from "@/config/site";

const CATS = [
  "Account & login help",
  "Nova Premium & purchases",
  "Bank-statement analysis",
  "Bug reports & technical issues",
  "Privacy & data requests",
  "General questions & feedback",
];

const QUICK = [
  { to: "/support", label: "Support", icon: LifeBuoy },
  { to: "/privacy", label: "Privacy Policy", icon: ShieldCheck },
  { to: "/terms", label: "Terms of Use", icon: FileText },
  { to: "/delete-account", label: "Delete Account", icon: Trash2 },
];

export default function Contact() {
  return (
    <>
      <SEO title="Contact Nova" description="Get in touch with the Nova team. Email support or use our secure contact form." path="/contact" />
      <PageHeader
        eyebrow="Contact"
        title="Get in touch"
        subtitle="Have a question or need a hand? Email us directly or send a message using the secure form below."
      />
      <section className="pb-24">
        <div className="container-nova grid gap-10 lg:grid-cols-[1fr_1.1fr]">
          <Reveal>
            <div className="space-y-6">
              <a
                href={`mailto:${SITE.supportEmail}`}
                className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.02] p-5 transition-colors hover:border-nova-cyan/40"
                data-testid="contact-email-link"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-nova-cyan">
                  <Mail size={20} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">Email support</p>
                  <p className="text-sm text-white/60">{SITE.supportEmail}</p>
                </div>
              </a>

              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5">
                <p className="text-sm font-semibold text-white">What we can help with</p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2">
                  {CATS.map((c) => (
                    <li key={c} className="flex items-start gap-2 text-sm text-white/60">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-nova-emerald" /> {c}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5">
                <p className="text-sm font-semibold text-white">Helpful links</p>
                <div className="mt-3 grid grid-cols-2 gap-3">
                  {QUICK.map((q) => {
                    const Icon = q.icon;
                    return (
                      <Link
                        key={q.to}
                        to={q.to}
                        className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2.5 text-sm text-white/70 transition-colors hover:text-white"
                        data-testid={`contact-quick-${q.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-+$/, "")}`}
                      >
                        <Icon size={15} className="text-nova-cyan" /> {q.label}
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
